import { InputHTMLAttributes } from 'react';
import { FieldMetaState } from 'react-final-form';

import { getMetaError } from 'shared/functions/errors';
import { linkifyError } from 'shared/functions/_functions';
import { getClassNames, noop } from 'shared/functions/utils';

type Props = {
  input: InputHTMLAttributes<HTMLInputElement>;
  meta?: FieldMetaState<any>;
  label?: string;
  placeholder?: string;
  valueClass?: string;
  formClass?: string;
  postfix?: string;
  prefix?: string;
  labelClass?: string;
  type?: string;
  min?: number;
  max?: number;
  step?: number;
  postfixClass?: string;
  postfixAddonClass?: string;
  postfixOnClick?: () => void;
  maxLength?: number;
  disabled?: boolean;
  nullify?: boolean;
};
export const Input = ({ input, meta, ...rest }: Props) => {
  const { label = null, placeholder } = rest;
  const error = getMetaError(meta);
  const showError = error && <div className="errorMsg">{linkifyError(error)}</div>;
  const postfixOrPrefix = rest.postfix || rest.prefix;
  return (
    <div data-testid={input.name} className={getClassNames('form-group', rest.formClass)}>
      {label !== null && <label className={getClassNames('control-label', rest.labelClass)}>{label}</label>}
      <div className={getClassNames(rest.valueClass, (rest.prefix || rest.postfix) && 'input-group')}>
        {rest.prefix && <span className="input-group-addon">{rest.prefix}</span>}
        <input
          className="form-control"
          type={rest.type || 'text'}
          placeholder={placeholder || label}
          disabled={rest.disabled}
          min={rest.min}
          max={rest.max}
          step={rest.step}
          maxLength={rest.maxLength}
          {...input}
          onBlur={(evt) => {
            input.onBlur?.(evt);

            if (typeof input.value === 'string') {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error TODO This type is incorrect
              input.onChange?.(input.value.trim());
            }

            if (rest.type === 'number') {
              const parsedValue = parseFloat(input.value as string);
              let result;
              if (`${parsedValue}` === `${input.value}`) {
                result = parsedValue;
              } else {
                result = rest.nullify ? null : 0;
              }
              input.onChange(result);
            }

            if (rest.nullify) {
              input.onChange?.(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error TODO This type is incorrect
                input.value || (rest.nullify ? null : input.value),
              );
            }
          }}
        />
        {rest.postfix && (
          <span
            className={getClassNames('input-group-addon', rest.postfixClass)}
            onClick={rest.postfixOnClick || noop}
            style={{
              cursor: rest.postfixOnClick ? 'pointer' : '',
            }}
          >
            <span className={rest.postfixAddonClass || ''}>{rest.postfix}</span>
          </span>
        )}
        {!postfixOrPrefix && showError}
      </div>
      {postfixOrPrefix && showError}
    </div>
  );
};
